<app-page-layout>
    <sh-breadcrumbs breadcrumbs>
        <sh-breadcrumb-item [label]="'common.general.home' | translate" href="/"></sh-breadcrumb-item>
        <sh-breadcrumb-item
            [label]="'pending-requests.breadcrumb' | translate"
            href="/escalation/pending-requests"
        ></sh-breadcrumb-item>
    </sh-breadcrumbs>

    <h1 title class="text-2xl font-bold font-sh-bree-headline text-shui-text-strong">
        {{
            (totalEscalations() > 1
                ? 'common.action-required.multiple-pending-requests-action-required'
                : 'common.action-required.pending-request-action-required'
            ) | translate
        }}
    </h1>

    <app-table
        [items]="escalations()"
        [totalItems]="totalEscalations()"
        [pageSize]="pageSize"
        [currentPage]="currentPage()"
        [loading]="loading()"
        (pageChange)="onPageChange($event)"
    >
        <app-table-head>
            <app-table-header width="1fr" minWidth="200px">{{
                'pending-requests.request-id' | translate
            }}</app-table-header>
            <app-table-header width="1fr" minWidth="150px">{{
                'common.request-tables.status' | translate
            }}</app-table-header>
            <app-table-header width="1fr" minWidth="250px">{{
                'pending-requests.escalation-source' | translate
            }}</app-table-header>
            <app-table-header width="1fr" minWidth="150px"></app-table-header>
        </app-table-head>

        @for (escalation of escalations(); track escalation.id) {
            <app-table-row (click)="openRequest(escalation)" pillColor="#FFD200">
                <app-table-cell width="1fr" minWidth="200px"
                    >MDLA-{{ escalation.displayId ?? escalation.resourceId }}</app-table-cell
                >
                <app-table-cell width="1fr" minWidth="150px">{{
                    'escalation-status.' + escalation.status | translate
                }}</app-table-cell>
                <app-table-cell width="1fr" minWidth="250px">
                    @if (escalation.parentType === EscalationParentType.TEAM) {
                        {{ escalation.parentId | teamName | async }}
                    } @else {
                        {{ escalation.parentId | userName | async }}
                    }
                </app-table-cell>
                <app-table-cell width="1fr" minWidth="150px">
                    <sh-button
                        [label]="'pending-requests.take-action' | translate"
                        size="max-content"
                        (click)="openRequest(escalation); $event.stopPropagation()"
                    ></sh-button>
                </app-table-cell>
            </app-table-row>
        }
    </app-table>
</app-page-layout>
